import includes from 'lodash/includes';
import some from 'lodash/some';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const hasAccess = (user: any, permissions: string[]): boolean => {
  if (!user) return false;
  if (!user.user_role) return false;
  const role = user.user_role;
  if (role.permissions?.length === 0) return false;
  return some(role.permissions, (e) => {
    return includes(permissions, e.name);
  });
};

export const hasPermissions = (permissions: string[]) => {
  return (user: any) => hasAccess(user, permissions);
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default { hasAccess, hasPermissions };
